/* Product-specific Klaviyo draft IDs. No credentials. */
window.RakabotPopupProducts = {
  "8782944305376": {
    "handle": "rakabot-titan-5-16-18-caster-wheels-kit",
    "name": "Titan & Zeus caster wheel kit",
    "forms": {
      "French": "TQZWSM",
      "English": "V2qMLD"
    }
  },
  "8779121098976": {
    "handle": "rakabot-titan-pipe-kits-and-large-container",
    "name": "Titan drainage pipes and large collector",
    "forms": {
      "French": "WbPCEv",
      "English": "Xmetym"
    }
  },
  "8719979741408": {
    "handle": "rakabot-plastico-2x-extra-containers",
    "name": "Plastico replacement collectors",
    "forms": {
      "French": "RTjyFw",
      "English": "URah5R"
    }
  },
  "8562645958880": {
    "handle": "boot-rack-19-wide-rustproof-with-containers-2-to-8-shelves-rakabot-titan",
    "name": "Titan 19-inch",
    "forms": {
      "French": "SrHkWK",
      "English": "TB8bQB"
    }
  },
  "8557876084960": {
    "handle": "boot-rack-29-wide-rustproof-with-containers-2-to-8-shelves-rakabot-titan",
    "name": "Titan 29-inch",
    "forms": {
      "French": "WyWUeW",
      "English": "VVVRCj"
    }
  },
  "8557864321248": {
    "handle": "boot-rack-38-wide-rustproof-with-containers-2-to-8-shelves-rakabot-titan",
    "name": "Titan 38-inch",
    "forms": {
      "French": "ViUNZG",
      "English": "STtSSA"
    }
  },
  "7996831039712": {
    "handle": "clothing-rack-with-footwear-shelves-rakabot-zeus",
    "name": "Zeus",
    "forms": {
      "French": "WujDTy",
      "English": "XDJuMq"
    }
  },
  "7920864133344": {
    "handle": "rakabot-plastico-4x-extra-legs",
    "name": "Plastico extra legs",
    "forms": {
      "French": "WpGpya",
      "English": "UwDfGh"
    }
  },
  "7785467150560": {
    "handle": "boot-rack-stylish-rustproof-metal-stores-7-pairs-rakabot-signature",
    "name": "Signature",
    "forms": {
      "French": "UrZZkT",
      "English": "XpQHKe"
    }
  },
  "7553992294624": {
    "handle": "boot-rack-47-wide-rustproof-with-containers-2-to-8-shelves-rakabot-titan",
    "name": "Titan 47-inch",
    "forms": {
      "French": "RVVNSp",
      "English": "RiULfL"
    }
  },
  "7520039010528": {
    "handle": "moderno-entrance-bench-with-self-draining-boot-rack-shelf-and-water-collecting-bucket",
    "name": "Moderno",
    "forms": {
      "French": "TDJs3u",
      "English": "SpGkNe"
    }
  },
  "7495330267360": {
    "handle": "stackable-self-draining-and-water-collecting-plastic-boot-rack-23-5-inches-wide-store-2-pairs-per-tier",
    "name": "Plastico",
    "forms": {
      "French": "U7uXXj",
      "English": "VgTNRb"
    }
  },
  "7495331315936": {
    "handle": "entrance-bench-w-draining-shelf-container-rakabot-noble",
    "name": "Noble",
    "forms": {
      "French": "YeJxfw",
      "English": "RBqMuP"
    }
  },
  "7495330857184": {
    "handle": "locker-shelf-organizer-boots-storage-channeling-water-rakabot-locker1",
    "name": "Locker1",
    "forms": {
      "French": "UzfvTa",
      "English": "TWetgx"
    }
  }
};
